"use client"
import React, { useState, useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";

const ScrollTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Agregar un listener de evento de desplazamiento para controlar la visibilidad del botón
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Eliminar el listener de evento cuando el componente se desmonte
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 500, // Duración de la animación en milisegundos
      smooth: "easeInOutQuart", // Función de suavizado de la animación
    });
  };


  return (
    <>
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-top-button"></button>
      )}
    </>
  );
};

export default ScrollTopButton;
